import {getSelectedResidentialAddress} from '../selectors/selectors';
import doMetric from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';

export default (getState) => {
  if (!window.dataLayer?.push || typeof window.dataLayer?.push !== 'function') return 'fail';
  
  const {order} = window.start;
  
  const partialResidentialPostcode = getSelectedResidentialAddress(getState())?.postCode?.split(' ')[0];
  
  try {
    const gtmDeliveryData = {
      event: 'homebase',
      orderInfo: order.basketItems.map((basketItem) => {
        let postcode;
        let storeName;
    
        const isFulfilmentMethodHomeDelivery = basketItem.fulfilmentMethod === 'HOME_DELIVERY';
    
        if (isFulfilmentMethodHomeDelivery) {
          postcode = partialResidentialPostcode;
        } else {
          storeName = basketItem?.store?.name;
          postcode = basketItem?.store?.postcode;
        }
    
        return {
          sku: basketItem.externalProductId || basketItem.productId || '',
          fulfillmentMethod: basketItem.fulfilmentMethod || '',
          storeName: storeName || '',
          postcode: postcode || '',
          deliveryServiceStatus: '',
          checkoutStatus: 'FAILURE',
        };
      }),
    };
    
    window.dataLayer.push(gtmDeliveryData);
  
    try {
      const orderInfoNoPostcode = gtmDeliveryData.orderInfo.map(basketItem => ({...basketItem, postcode: 'OBSCURED'}));
      const gtmDeliveryDataStringified = JSON.stringify({...gtmDeliveryData, orderInfo: orderInfoNoPostcode});
      doMetric('gtmPushFailureDeliveryDataToCheckoutPage', [{name: 'deliveryData', value: gtmDeliveryDataStringified}], [], 'impression');
    } catch (e) {
      Track.track(e);
    }
  } catch {
    return 'fail';
  }
  
  return 'success';
};
